import { useNavigate } from 'react-router-dom'

import { Arrow, CheckDot } from './icons'

// Letter 97 p.4: "7-day free trial" at both widths (the 360 frame draws "7-days").
const TRUST = ['7-day free trial', 'Analyze up to 5 properties', 'No credit card required']

// Figma 29.09 `cta-prefoot_2` (1440 x 260) / `cta-prefoot` (360 x 404), spec §2.8.
const CallToAction = () => {
  const navigate = useNavigate()

  return (
    <section className="relative overflow-hidden bg-brand-dark">
      <span
        aria-hidden="true"
        className="absolute w-[236px] h-[236px] rounded-full bg-brand-primary opacity-[0.11] blur-[45.65px] left-[calc(50%-339px)] md:left-[calc(50%-568px)] top-[-10px]"
      />
      <span
        aria-hidden="true"
        className="hidden md:block absolute w-[52px] h-[52px] rounded-full bg-brand-primary opacity-[0.91] blur-[45.65px] left-[calc(50%+480px)] top-[169px]"
      />

      <div className="relative max-w-canvas mx-auto px-5 md:px-6 canvas:px-0 pt-10 pb-[46px] md:pt-12 md:pb-12 flex flex-col items-center text-center">
        {/* D13: the two frames colour this heading differently; each width keeps its own. */}
        <h2 className="text-[28px] leading-[38px] md:text-[38px] md:leading-[48px] font-extrabold text-white md:text-brand-greenSec">
          Ready to Analyze <br className="md:hidden" />
          <span className="text-brand-primary md:text-[#43B017]">Your Next Deal?</span>
        </h2>

        <div className="mt-9 md:mt-5 w-full md:w-auto flex flex-col gap-[18px]">
          {/* Canvas: this button stays on mobile only. Hover is not drawn (M8); it borrows the
              navbar Login outline hover. */}
          <button
            type="button"
            onClick={() => navigate('/pricing')}
            className="md:hidden h-14 rounded-full border border-brand-fieldBdr text-white text-[16px] font-semibold hover:text-brand-primary hover:border-brand-primary transition-colors"
          >
            View Pricing
          </button>
          <button
            type="button"
            onClick={() => navigate('/signup')}
            className="h-14 md:pl-10 md:pr-[29px] rounded-full bg-brand-primary hover:bg-brand-hover text-white text-[16px] font-semibold inline-flex items-center justify-center gap-3 transition-colors"
          >
            Start Your Free Trial
            <Arrow />
          </button>
        </div>

        <ul className="mt-3 max-w-[320px] md:max-w-none flex flex-wrap md:flex-nowrap justify-center gap-x-6 gap-y-2 text-white">
          {TRUST.map((t) => (
            <li key={t} className="flex items-center gap-1 h-7 text-[11px] md:text-[12px] md:font-medium whitespace-nowrap">
              <CheckDot dotClass="bg-brand-primary" ringClass="w-7 h-7 bg-white/5" />
              {t}
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}

export default CallToAction
